<template>
  <abbr
    :class="classNames"
    v-html="measure.toString()"></abbr>
</template>

<script>
import Measure from '@/models/Measure'
export default {
  name: 'MeasureFormat',
  props: {
    dimension: String,
    quantity: Object,
    rangeEnd: Object,
    scale: {
      type: String,
      default: '1'
    },
    unit: String,
    modifier: String,
    modifierType: String
  },
  computed: {
    measure () {
      let measure = new Measure(this.$props)
        .scale(this.scale)
        .convert(this.$preference('system'))
      return this.scale === '1' ? measure : measure.simplify()
    },
    classNames () {
      let classNames = {
        'format--measure': true,
        'format--measure-scaled': this.scale !== '1'
      }
      classNames[`measure--${this.dimension}`] = true
      return classNames
    }
  }
}
</script>

<style lang="sass">
abbr.format--measure
  font-weight: 500
  text-decoration: none
  border-radius: 4px
  display: inline-block
  line-height: 23px
  // padding: 0 4px
  // background: #f5f7f9
  &.measure--temperature
    border-bottom-color: #fee6b1
  &.format--measure-scaled
    // color: #1165d4
    // border-bottom: 1px dashed #1165d4
    // background: #fef5fa
    color: #1A73E8
    // #7e0048
  .user__clad--true &
    border-bottom: 2px solid #aad0f1
    cursor: pointer
</style>



// WEBPACK FOOTER //
// src/components/Formats/Measure.vue